import { FEEDBACK_ROUTES } from '../../constants/_routes'
import feedbackTypes from '../../constants/feedbackTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const feedback_index_request = () => {
  return {
    type: feedbackTypes.index.request
  }
}

const feedback_index_success = (response) => {
  return {
    type: feedbackTypes.index.success,
    payload: response.data
  }
}

const feedback_index_failure = (messages) => {
  return {
    type: feedbackTypes.index.failure,
    payload: messages
  }
}

const feedback_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(feedback_index_request())

    // Request
    axios.get(
      FEEDBACK_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( feedback_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching feedback."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( feedback_index_failure(errors))
    })
  }

}

export {
  feedback_index
}



// WEBPACK FOOTER //
// ./src/js/actions/feedback/getindex.js